import { useEffect, useState } from "react";
import { Clock, MapPin, Info } from "lucide-react";
import api from "@/lib/api";
import { PageHero, Reveal, EmptyState } from "@/components/public/Shared";

export default function Services() {
  const [services, setServices] = useState(null);

  useEffect(() => {
    api.get("/public/services").then((r) => setServices(r.data)).catch(() => setServices([]));
  }, []);

  return (
    <div data-testid="services-page">
      <PageHero
        title="Worship & Services"
        subtitle="Come as you are. All are welcome to worship with us."
        image="https://images.unsplash.com/photo-1570786032462-2efc3ca8fccd?q=80&w=1800&auto=format&fit=crop"
      />
      <div className="mx-auto max-w-5xl px-5 py-16 sm:px-8 sm:py-24">
        {services && services.length === 0 && (
          <EmptyState
            testId="services-empty"
            title="Service timings coming soon"
            text="Our weekly worship schedule will be published here shortly. Please check back or contact us for details."
          />
        )}
        <div className="grid gap-6 md:grid-cols-2">
          {(services || []).map((svc, i) => (
            <Reveal key={svc.id} delay={i * 0.06}>
              <article className="h-full rounded-lg border border-border bg-white p-8 shadow-sm transition-transform duration-300 hover:-translate-y-1" data-testid={`service-card-${svc.id}`}>
                <h3 className="font-heading text-2xl font-bold text-navy">{svc.name}</h3>
                <div className="mt-4 space-y-2 text-sm text-foreground/80">
                  <p className="flex items-center gap-2"><Clock className="h-4 w-4 text-gold" /> {svc.day} {svc.time ? `· ${svc.time}` : ""}</p>
                  {svc.location && <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-gold" /> {svc.location}</p>}
                </div>
                {svc.description && <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-line">{svc.description}</p>}
                {svc.notes && (
                  <p className="mt-4 flex items-start gap-2 rounded-md bg-secondary px-4 py-3 text-xs text-foreground/70">
                    <Info className="h-4 w-4 shrink-0 text-gold-dark" /> {svc.notes}
                  </p>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
